<template>
  <div     v-loading="loading">
    <hr-dialog width="80%" :visible.sync="dialogVisible" :operatorModel='operatorModel' :title="title" >
      <template slot="body">
        <el-form ref="formRef" :rules="formRules" :model="form" label-width="90px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="项目名称" prop="projectId">
                <el-select
                  :disabled="pageStatus"
                  v-model="form.projectId"
                  placeholder="请选择"
                  style="width:100%"
                  @change="projectIdChange"
                >
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="设备名称" prop="deviceId">
                <div style="display:flex">
                  <el-input v-model="form.deviceName" disabled placeholder="请选择 设备"></el-input>
                  <el-button type="primary" size="small" @click="choiceDevice" v-if="!pageStatus&&operatorObject!='device'"
                    >选择</el-button
                  >
                </div>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="设备类型" prop="deviceType">
                <el-input v-model="form.deviceType" disabled></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="设备编号" prop="code">
                <el-input disabled v-model="form.code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属部门" prop="deptName">
                <el-input disabled v-model="form.deptName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="存放位置" prop="areaName">
                <el-input disabled v-model="form.areaName"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8" style="height:54px">
              <el-form-item label="巡检时间" prop="realInspectTime" style="width:100%">
                <el-date-picker
                  :disabled="pageStatus"
                  style="width:100%"
                  v-model="form.realInspectTime"
                  type="datetime"
                  placeholder="请选择 日期时间"
                  align="right"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="巡检人员" prop="realInspectManId">
                <choice-people
                  :limit="1"
                  :allUserList="realInspectManList"
                  :remainUserListInside.sync="realInspectManList"
                  :projectId="form.projectId"
                  :disabled="pageStatus"
                  :message="请选择巡检人"
                ></choice-people>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="form.orderCode">
              <el-form-item label="工单编号" prop="orderCode">
                <el-input disabled v-model="form.orderCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="巡检标准" prop="standardId">
                <el-select
                  :disabled="pageStatus"
                  v-model="form.standardId"
                  placeholder="请选择巡检"
                  style="width:100%"
                  @change="inspectStandardChange"
                >
                  <el-option
                    v-for="item in deviceInspectStandardList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled ="item.disabled"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <h6>巡检标准（单选）</h6>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="InspectionStatus">
                <el-table :data="standardList" border style="width: 100%">
                  <el-table-column type="index" label="序号" width="50"> </el-table-column>
                  <el-table-column prop="standardDetailContent" label="标准内容"> </el-table-column>
                  <el-table-column label="操作" width="300">
                    <template slot-scope="scope">
                      <div>
                        <el-button
                          size="mini"
                          type="primary"
                          :disabled="item.dictKey == scope.row.selectedOperation"
                          v-for="(item, index) in currentDataOption"
                          :key="index"
                          @click="standardEvaluate(scope.row, item.dictKey, item.dictValue)"
                          class="standard-el-button"
                          >{{ item.dictValue }}</el-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <h6>巡检标准（填写）</h6>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="InspectionStatus">
                <el-table :data="deviceInspectTaskListReadings" border style="width: 100%">
                  <el-table-column type="index" label="序号" width="50"> </el-table-column>
                  <el-table-column prop="readingName" label="巡检项名称"> </el-table-column>
                  <el-table-column prop="valueRangeMinRecord" label="参考下线"> </el-table-column>
                  <el-table-column prop="valueRangeMaxRecord" label="参考上线"> </el-table-column>
                  <el-table-column prop="valueDefaultRecord" label="参考标准"> </el-table-column>
                  <el-table-column prop="actualInspectValue" label="巡检数值">
                    <template slot-scope="scope">
                      <el-input
                      :disabled="operatorModel=='view'"
                      v-model="scope.row.actualInspectValue"
                      @input="
                        (e) => {
                          regValue(e, scope.row, 'actualInspectValue');
                        }
                      "
                      @blur="actualInspectValueBlur(scope.row)"></el-input>

                    </template>
                  </el-table-column>
                  <el-table-column label="结果" width="100">
                    <template slot-scope="scope">

                       <el-tag v-show="scope.row.errorFlag!=''" :type="scope.row.errorFlag=='0'?'success':'danger'">{{scope.row.errorFlag =='0'?'正常':'异常'}}</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="巡检结果" prop="errorFlag">
                <el-select
                  :disabled="pageStatus"
                  v-model="form.errorFlag"
                  placeholder="请选择 巡检结果"
                >
                  <el-option
                    v-for="item in inspectionResultList"
                    :key="item.errorFlag"
                    :label="item.name"
                    :value="item.errorFlag"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="description">
                <el-input
                  placeholder="请输入 备注"
                  :disabled="pageStatus"
                  type="textarea"
                  v-model="form.description"
                  maxlength="200"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="上传附件" prop="code">
                <VUpload :disabled="pageStatus" :fileList="form.attachList">
                </VUpload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <hr-dialog
          title="选择设备"
          v-if="choiceDeviceDialogFlag"
          :visible.sync="choiceDeviceDialogFlag"
         :allowFull='false'
          width="80%"
        >
         <template slot="body">
            <choiceDevice
            @cancelOperate="choiceDeviceCancleOperate"
            :projectId="this.form.projectId"
            @choiceData="getDevice"
          ></choiceDevice>
         </template>
        </hr-dialog>
      </template>
      <template slot="footer" v-if="!pageStatus">
        <div class="btnArea" style="text-align:right;margin-right:24px">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="submitRecord"
            style="margin-right: 20px"
            >{{operatorModel=='add'?'保存':'修改'}}</el-button
          >
          <el-button @click="dialogClose" size="small" icon="el-icon-circle-close">取消</el-button>
        </div>
      </template>
    </hr-dialog>

    <!-- 选择设备对话框 -->
  </div>
</template>

<script>
import bussinessLogic from './inspect.js';

import {
  getBisDictData,
  getStandardByDeviceId,
  taskStandardReadingByDevice,
  taskByStandardId,
  saveInspectRecord,
  updateInspectRecord,
} from '@/api/crmedical/device/deviceInspectionStandard';

import choiceConsumable from '@/components/consumable/choiceConsumable';
import choiceDevice from '@/components/device/deviceChoice/index';
import VUpload from '@/views/components/v-upload';
import choiceContract from '@/components/choiceContract/choiceContract';
import ATime from '@/components/aTime/index';
import choicePeople from '@/components/user-edit-box/user-edit-box2';
import { getGroupListByModuleType } from '@/api/crmedical/group/group';

export default {
  components: { VUpload, choiceContract, choiceDevice, choiceConsumable, ATime, choicePeople },
  props: {
    bussinessModel: {
      type: String,
      default: 'temporary',
    },
    deviceForm:{},//设备模式传来的设备信息
    //add update view
    operatorModel: {
      type: String,
      default: 'add',
    },
    cancelBtn: {
      type: Boolean,
      default: true,
    },
    //操作对象:普通记录record  设备记录device
    operatorObject: {
      type: String,
      default: 'record',
    },
    //弹框属性
    dialogVisible: {
      default: false,
      type: Boolean,
    },
    //弹框标题
    title: {
      default: '',
      type: String,
    },
    handleClose: {
      default: () => {},
    },
    projectList: [],
    projectId: '',
    row: {},
  },
  data() {
    return {
      loading:false,
      deviceInspectStandardList:[],//巡检标准集合
      oldValue:'',
      inspectStandardReading: [],
      form: {
        projectId: '',
        deviceName: '',
        deviceId: '',
        deviceType: '',
        code: '',
        deptName: '',
        areaName: '',
        realInspectTime: '',
        realInspectManId: '',
        realInspectManName: '',
        deviceInspectTaskListStandards: [],
        errorFlag: '',
        attachList: [],
        description: '',
      },

      checkDetail: () => {},
      addRecord: () => {},
      updateRecord: () => {},

      realInspectManList: [], //巡检人集合，配合使用选人组件
      inspectionResultList: [
        {
          errorFlag: 1,
          name: '异常',
        },
        {
          errorFlag: 0,
          name: '正常',
        },
      ],
      deviceInspectTaskListReadings: [], //填写
      standardList: [],
      currentDataOption: [],
      handleIdList: [], //处理人
      OperateList: [],
      isUpdate: false,
      //判断是否为编辑
      operatConsumableIndex: undefined,
      choiceConsumableFlag: false, //选择耗材对话框
      choiceContractDialogFlag: false, //选择设备对话框
      choiceDeviceDialogFlag: false, //选择设备对话框
      consumable: {
        consumableId: '',
        consumableName: '',
        specification: '',
        vender: '',
        consumeNum: '',
        consumePrice: '',
      },
      consumablesList: [
        {
          consumableId: '',
          consumableName: '',
          specification: '',
          vender: '',
          consumeNum: '',
          consumePrice: '',
        },
      ],
      dialogConstract: {},
      formRules: {
        deviceId: [{ required: true, message: '请选择设备', trigger: 'change' }],
        projectId: [{ required: true, message: '请选择项目', trigger: 'change' }],
        realInspectTime: [{ required: true, message: '请选择巡检时间', trigger: 'blur' }],
        realInspectManId: [{ required: true, message: '请选择巡检人', trigger: 'change' }],
        errorFlag: [{ required: true, message: '请选择巡检结果', trigger: 'blur' }],
      },
    };
  },
  created() {
    console.log("设备传来的row2",this.row)
    console.log("传递模式",this.operatorObject)
    this.initLogicManagement();//初始化业务接口
    this.initForm();
    this.initData();
  },
  computed: {
    pageStatus() {
      let flag = this.operatorModel == 'view' ? true : false;
      return flag;
    },
  },
  watch: {
    realInspectManList: {
      handler() {
        if (this.realInspectManList.length > 0) {
          this.$set(this.form, 'realInspectManId', this.realInspectManList[0].id);
          this.form.realInspectManName = this.realInspectManList[0].realName.replace(
            /\([0-9]*\)(?!.*\1)/g,
            ``
          ); //删除手机号
        }
      },
      immediate: true,
      deep: true,
    },
    dialogVisible() {
      console.log("巡检组件的dialogVisible", this.dialogVisible)
      this.$emit('update:dialogVisible', this.dialogVisible);
    },
  },
  methods: {
    //巡检标准单选
    initInspectItemInput(data) {
        let arry = [];
        console.log('巡检结果', data);
        data.forEach((item, index) => {
          let obj = {
            deviceId: this.form.deviceId,
            projectId: item.projectId,
            readingId: item.id,
            standardId: item.standardId,
            readingName: item.name,
            valueRangeMinRecord: item.valueRangeMin,
            valueRangeMaxRecord: item.valueRangeMax,
            valueDefaultRecord: item.valueDefault,
            actualInspectValue: '',
            errorFlag: '',
          };
          arry.push(obj);
        });
        this.deviceInspectTaskListReadings = arry;

    },
    //切换巡检标准
    inspectStandardChange(val){
      this.initInspectItemByChoice(val)
      this.deviceInspectStandardList.forEach((item,index)=>{
        if(item.id == val){
          this.inspectItemButton(item.optionalOperations.split(','));
        }
      })
      taskStandardReadingByDevice({ id: val }).then(({ data }) => {
        this.initInspectItemInput(data);
      });
    },
    regValue(value, obj, field) {
      if (obj[field] + '') {
        // obj[field] = obj[field].replace(/[^(\d|.|\-)]/g,'')
        // let reg = /^-?([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
        let reg = /^(-?)\d{1,9}(\.\d{0,2})?$/;
        if (reg.test(obj[field])) {
          this.oldValue = value;
          console.log('old', this.oldValue);
        } else {
          if (obj[field] == '-' || !obj[field]) {
            obj[field] = obj[field];
          } else {
            let length = (obj[field] + '').length;

            if (length == 1) {
              obj[field] = '';
            } else {
              obj[field] = this.oldValue;
            }
          }
        }
      }
    },
    //弹框关闭回调
    InspectClose(){
      // this.$confirm(' 是否关闭继续?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {

      //      this.dialogVisible = false;
      //   }).catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '已取消操作'
      //     });
      //   });


    },
    initForm() {
      switch (this.operatorModel) {
        case 'view':
          this.getInspectDetail(this.row.id);
          break;
        case 'update':
          this.getInspectDetail(this.row.id);
          break;
        case 'add':
          if(this.operatorObject == 'device'){
              this.deviceAddInspectInitForm(this.deviceForm)
              console.log("巡检组件",this.form);
          }else{
            this.form.projectId = this.projectId;
          }

          console.log(this.form);
          break;
        default:
          return;
      }
    },
     deviceAddInspectInitForm(obj){

      let objValue = {
        areaName:obj.areaName,
        attachList:[],
        code:obj.code,
        deptName:obj.deptName,
        description:'',
        deviceId:obj.id,
        id:obj.id,
        deviceInspectTaskListReadings:[],
        deviceInspectTaskListStandards:[],
        deviceName:obj.name,
        deviceType:obj.typeName,
        errorFlag:1,
        optionalOperationValues:'',
        optionalOperations:'',
        projectId:obj.projectId,
        realInspectManId:'',
        realInspectManName:'',
        realInspectTime:'',
        standardId:'',
        standardName:'',
      }
      this.form = Object.assign({},objValue)

    },
    getInspectDetail() {
      this.checkDetail(this.row.id).then(async (res) => {
        this.form = res;
        console.log("回显数据",this.form)
        let obj = {
          id: this.form.realInspectManId,
          realNameAndPhone: this.form.realInspectManName,
          realName: this.form.realInspectManName,
        };
        this.realInspectManList.push(obj);
        console.log('form里的statnt',this.form.deviceInspectTaskListStandards)
        getStandardByDeviceId({ id: this.form.deviceId }).then(res=>{
          this.deviceInspectStandardList = res.data
          //巡检数据冗余
          console.log('dddd')
          let isInspectStandardChange = false
          this.deviceInspectStandardList.forEach(item=>{
            if(this.form.standardId == item.id){
              isInspectStandardChange = true
            }
          })
          if(!isInspectStandardChange){
            let obj = {
              id:this.form.standardId,
              name:this.form.standardName,
              disabled:true
            }
            this.deviceInspectStandardList.push(obj)
          }
          //end
        })
        this.initInspectItem(this.form.deviceInspectTaskListStandards);
        this.initInspectItemInputByChoice(this.form.deviceInspectTaskListReadings);
        await this.getBisDictData();
        this.inspectItemButton(this.form.optionalOperations);
      });
    },
    initLogicManagement() {
      this.initBussinessFunction(); //初始化调用方法
    },
    initBussinessFunction() {
      switch (this.bussinessModel) {
        case 'temporary': //临时巡检
          //初始化新增查看接口方法
          this.checkDetail = bussinessLogic.checkTemporaryDetail;
          this.addRecord = bussinessLogic.addTemporaryRecord;
          this.updateRecord = bussinessLogic.updateTemporaryRecord;
          break;
        case 'workOrder': //工单巡检
          //初始化新增查看接口方法
          this.checkDetail = bussinessLogic.checkWorkOrderDetail;
          this.addRecord = bussinessLogic.addWorkOrderRecord;
          this.updateRecord = bussinessLogic.updatWorkOrderRecord;
          break;
      }
    },
    choiceDeviceCancleOperate() {
      this.choiceDeviceDialogFlag = false;
    },
    //新增获取巡检标准
   async initInspectItemByChoice(standardId) {
      let {data} =await taskByStandardId({id:standardId})
      console.log('巡检单选', data);

        this.standardList = data;
        this.standardList.forEach((item) => {
          item.standardDetailContent = item.content;
        });

    },
    //查看编辑处理巡检标准
    initInspectItem(data){
      this.standardList = data;

    },
    //巡检标准切换设备
    initInspectItemInputByChoiceChange(data){
       let arry = [];
        console.log('巡检结果', data);
        data.forEach((item, index) => {
          let obj = {
            deviceId: this.form.deviceId,
            projectId: item.projectId,
            readingId: item.id,
            standardId: item.standardId,
            readingName: item.name,
            valueRangeMinRecord: item.valueRangeMin,
            valueRangeMaxRecord: item.valueRangeMax,
            valueDefaultRecord: item.valueDefault,
            actualInspectValue: '',
            errorFlag: '',
          };
          arry.push(obj);
        });
        this.deviceInspectTaskListReadings = arry;
    },
    //巡检标准单选
    initInspectItemInputByChoice(data) {
      if (this.operatorModel == 'add') {
        let arry = [];
        console.log('巡检结果', data);
        data.forEach((item, index) => {
          let obj = {
            deviceId: this.form.deviceId,
            projectId: item.projectId,
            readingId: item.id,
            standardId: item.standardId,
            readingName: item.name,
            valueRangeMinRecord: item.valueRangeMin,
            valueRangeMaxRecord: item.valueRangeMax,
            valueDefaultRecord: item.valueDefault,
            actualInspectValue: '',
            errorFlag: '',
          };
          arry.push(obj);
        });
        this.deviceInspectTaskListReadings = arry;
      } else {
        data.forEach(item=>{
          item.errorFlag+=''
        })
        this.deviceInspectTaskListReadings = data;
      }
    },
    //巡检项按钮的渲染
    inspectItemButton(optionalOperations) {
      console.log("optionalOperations==",optionalOperations)
      this.currentDataOption = []
      let arry; //当前设备所拥有的选项编号
      if (typeof optionalOperations == 'string') {
        arry = optionalOperations.split(',');
      } else {
        arry = optionalOperations;
      }
      console.log('dsads', this.OperateList, arry);
      this.OperateList.forEach((item) => {
        arry.forEach((ele) => {
          if (item.dictKey == ele) {
            let obj = {
              dictKey: item.dictKey,
              dictValue: item.dictValue,
            };
            this.currentDataOption.push(obj);
          }
        });
      });
      console.log("巡检单选按钮集合",this.currentDataOption);
    },
    clearInspectRelation() {
      this.currentDataOption = [];
      this.standardList = [];
    },
    inspectItemCheck() {
      let result = true;
      if (this.standardList.length > 0) {
        for (let i = 0; i < this.standardList.length; i++) {
          if (this.standardList[i].selectedOperation) {
            continue;
          } else {
            this.$message.error('巡检标准必须全部评价！');
            result = false;
          }
        } //判断是否所有的标准都评价了
      }
      return result;
    },
    projectIdChange(val) {
      getBisDictData({
        code: 'project_device_inspect_operation',
        projectId: val,
      }).then((res) => {
        this.OperateList = res.data;
      });
      this.tool.clearObject(this.form, 'projectId');

      this.handleIdList = [];
      this.realInspectManList = [];
      this.clearInspectRelation();
      this.$forceUpdate();
    },
    standardEvaluate(row, optionValue, optionName) {
      if (this.operatorModel != 'view') {
        this.$set(row, 'selectedOperation', optionValue);
        this.$set(row, 'selectedOperationValue', optionName);
        this.$message.success('操作成功');
        console.log('操作后', this.standardList);
      } else {
        return;
      }
    },
    maintenanceTime(date) {
      //维修完成时间
      this.form.serviceHour = Number(date.hour) * 60 + Number(date.minutes);
    },
    initData() {
      if (this.form.projectId) {
        this.getBisDictData();

      }
    },
    async getBisDictData() {
      await getBisDictData({
        code: 'project_device_inspect_operation',
        projectId: this.form.projectId,
      }).then((res) => {
        //操作按钮集合
        this.OperateList = res.data;
        if(this.operatorObject == 'device'&&this.operatorModel=='add'){
          //初始化巡检标准
           this.getDevice(this.form)
        }
      });
    },
    //巡检项的验证
    inspectItemValidate(){
      for(let i =0;i<this.deviceInspectTaskListReadings.length;i++){
        if(this.deviceInspectTaskListReadings[i].actualInspectValue==''){
           this.$message.error('有未操作巡检项，请核对！');
          return false
        }
      }
      return true
    },
    //巡检选择的验证
    inspectChoiceValidate(){
      if(this.standardList.length>0){
            for (let i = 0; i < this.standardList.length; i++) {
            if (this.standardList[i].selectedOperation) {
              continue;
            } else {
              // this.form.InspectionStatus = false;
              this.$message.error('有未操作巡检项，请核对！');
              return false;
            }
          } //判断是否所有的标准都评价了
          }
          return true
    },
    checkAllValidate(){
      if(this.inspectChoiceValidate()&&this.inspectItemValidate()){
        return true
      }else{
        return false
      }
    },
    submitRecord() {
      if(!this.checkAllValidate()){
        return
      }
      this.$refs['formRef'].validate(async (valid) => {
        if (valid) {
          let arrVaule = [];
          let arrName = [];
          console.log('this.currentDataOption', this.currentDataOption);
          this.currentDataOption.forEach((item) => {
            arrVaule.push(item.dictKey);
            arrName.push(item.dictValue);
          });

          let obj = {
            deviceInspectTaskListStandards: this.standardList,
            optionalOperations: arrVaule.join(','),
            optionalOperationValues: arrName.join(','),
          };
          if (this.standardList.length > 0) {
            //后端的要求
            obj.standardId = this.standardList[0].standardId;
            obj.standardName = this.standardList[0].standardName;
          }

            switch (this.operatorModel) {
              case 'add':
                this.loading = true
                this.addRecord(
                  Object.assign(
                    {},
                    this.form,
                    {
                      deviceInspectTaskListStandards: this.standardList,
                      deviceInspectTaskListReadings: this.deviceInspectTaskListReadings,
                    },
                    obj
                  ),

                ).then(()=>{
                  this.$emit('update:dialogVisible', false);
                    this.$emit('successCallBack')
                    this.$message.success('新增巡检记录成功');
                 
                }).catch(res=>{
                  this.loading = false
                })
                break;
              case 'update':
              this.loading = true
                this.updateRecord(
                  Object.assign(
                    {},
                    this.form,
                    {
                      deviceInspectTaskListStandards: this.standardList,
                      deviceInspectTaskListReadings: this.deviceInspectTaskListReadings,
                    },
                    obj
                  )
                ).then(() => {

                    this.$message.success('编辑巡检记录成功');
                     this.$emit('update:dialogVisible', false);
                    console.log("this.dialog",this.dialogVisible)
                    this.$emit('successCallBack')

                }).catch(res=>{
                  this.loading = false
                })
                break;
            }
        } else {
          console.log('表单验证失败!!');
          return false;
        }
      });
    },
   async getDevice(val) {
      console.log(val);
      console.log('查询标准dd');
      if(!val){
        this.$message({
          message: '请选择设备',
          type: 'warning'
        });
        return
      }
      this.clearInspectRelation();
      //根据设备id查找标准
    await  getStandardByDeviceId({ id: val.id }).then(({ data }) => {
        this.deviceInspectStandardList = [...data]
        if(data.length>0){
            this.form.standardId = data[0].id
             this.initInspectItemByChoice(this.form.standardId);
             this.inspectItemButton(data[0].optionalOperations.split(','));
               // //根据设备id查找标准(填写标准)
            taskStandardReadingByDevice({ id: this.form.standardId }).then(({ data }) => {
              this.initInspectItemInputByChoiceChange(data);
            });
          }

      
       

      });
    
      if(this.operatorObject !=='device'){
        this.$set(this.form, 'deviceId', val.id);
        this.$set(this.form, 'deviceName', val.name);

        this.form.areaName = val.areaName;
        this.form.deviceType = val.typeName;
        this.form.code = val.code;
        this.form.deptName = val.deptName;
      }

      this.choiceDeviceDialogFlag = false;
    },

    choiceDevice() {
      this.choiceDeviceDialogFlag = true;
    },

    closeRecord() {
      this.$emit('cancelOperate');
    },
    dialogClose() {
      this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           this.dialogVisible = false;
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });

    },
    inspectItemResult(value){
      console.log("选择结构",value)
      if(value){
        if(value==1){
          return '异常'
        }else{
          return '正常'
        }
      }else{
        return ''
      }
    },
    actualInspectValueBlur(row){
      let min = row.valueRangeMinRecord
      let max = row.valueRangeMaxRecord
      console.log('max:',max)
      console.log('min:',min)
      let value = row.actualInspectValue
      if(value){
        if(Number(value)>=Number(min)&&Number(value)<=Number(max)){
        row.errorFlag = '0';
        }else{

          row.errorFlag = '1';
        }

      }else{
        row.errorFlag = ''
      }
      this.$forceUpdate();
      console.log('计算机构',row.errorFlag)
    }
  },
};
</script>

<style lang="scss" scoped>
.standard-el-button {
  background: #c0c4cc;
  border-color: #c0c4cc;
  &.default,
  &.is-disabled,
  &.is-disabled:active,
  &.is-disabled:focus,
  &.is-disabled:hover {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
  }
}
.btn {
  width: 100%;
  border: none;
  height: 30px;
  background: #409eff;
  font-size: 25px;
  color: #fff;
  line-height: 30px;
  margin-top: 10px;
}
.btn::after {
  display: none;
}
.btnArea {
  margin-top: 10px;
  text-align: center;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
